import { useEffect, useState, useMemo } from "react";
import type { ITableSort } from "app/components/React/Table/types";
import { getColumns } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/columns/getColumns";
import { SWReactTableOptimized } from "app/components/React/Table/SWReactTableOptimized";
import type {
    ITableData,
    IRawData,
    IFilters,
} from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/types";
import { GhostLoader } from "app/components/React/Table/SWReactTableGhostLoader";
import { fetchData, transformData } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/utils";
import { TableTop } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/tableTop/TableTop";
import styled from "styled-components";
import { Box } from "@similarweb/ui-components";
import { useSelector } from "react-redux";
import { DemographicsUserBasedNoDataEvent } from "app/pages/website-analysis/demographics/services/DemographicsUserBasedWidgets";

const INITIAL_SORT: ITableSort = { sortDirection: "desc", field: "CompetitiveShare" };

const Container = styled(Box)`
    width: 100%;
    height: auto;
    margin-bottom: 100px;
`;

export const TrafficAndEngagementTable = () => {
    const [sort, setSort] = useState<ITableSort>(INITIAL_SORT);
    const { field, sortDirection } = sort;
    const [rawData, setRawData] = useState<IRawData>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [filters, setFilters] = useState<IFilters>({
        genderID: undefined,
        ageBucketIDs: [],
    });
    const { chosenItems } = useSelector((state) => {
        const { routing } = state;
        return routing;
    });
    const { genderID, ageBucketIDs } = filters;
    useEffect(() => {
        const noDataEvent = new DemographicsUserBasedNoDataEvent();
        setIsLoading(true);
        noDataEvent.reset("traffic and engagement table");
        fetchData(filters)
            .then((rawData) => {
                if (!rawData || Object.keys(rawData).length === 0) {
                    noDataEvent.noData("traffic and engagement table");
                }
                setRawData(rawData);
            })
            .catch(() => setRawData(undefined))
            .finally(() => setIsLoading(false));
    }, [genderID, ageBucketIDs]);

    const tableData: ITableData = useMemo(() => {
        const tableData = transformData(rawData, sort, chosenItems);
        return tableData;
    }, [field, sortDirection, rawData]);

    return isLoading ? (
        <GhostLoader />
    ) : (
        <Container>
            <TableTop
                filters={filters}
                setFilters={setFilters}
                totalCount={tableData?.Records?.length}
            />
            <SWReactTableOptimized
                type={"sticky"}
                tableData={tableData}
                tableColumns={getColumns(sort)}
                onSort={setSort}
            />
        </Container>
    );
};
